import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import App from './App';
import AboutUs from './components/AboutUs';
import AppAppBar from './components/AppAppBar';
import BlogDescription from './components/Blogdescription.js';
import Blogs from './components/Blogs';
import Careers from './components/Careers';
import ContactUs from './components/ContactUS';
import Footer from './components/Footer';
import GetQuoteModal from './components/GetQuoteModal';
import Journey from './components/Journey';
import Policies from './components/Policies';
import ProjectPage from './components/ProjectsPage';
import Services from './components/Services';
import TermsAndConditions from './components/TermsAndConditions';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ScrollToTop from './ScrollTop';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <ScrollToTop/>
  <AppAppBar />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/journey" element={<Journey />} />
        <Route path="/projects" element={<ProjectPage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<Careers />} />
        <Route path ="/GetQuote"element={<GetQuoteModal />} />
        <Route path ="/terms"element={<TermsAndConditions />} />
        <Route path ="/policies"element={<Policies />} />
        <Route path="/blogs" element={<Blogs/>} />
         <Route path="/blogs/:id" element={<BlogDescription />}/>

      </Routes>
      <Footer />
    </Router>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
